import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateQuebecMatrimonialRegimeType } from '/@/modules/estate/constants/EstateQuebecMatrimonialRegimeType';

export class EstateQuebecSpouseClaim extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {number}
   */
  familyPatrimonyContribution;

  /**
   * @var {number}
   */
  matrimonyAcquestContribution;

  /**
   * @var {string}
   */
  matrimonialRegimeType;

  /**
   * @var {string}
   */
  otherExplanation;

  /**
   * @var {string}
   */
  distributionValuesConfirmedAt;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.familyPatrimonyContribution = model.familyPatrimonyContribution;
    this.matrimonyAcquestContribution = model.matrimonyAcquestContribution;
    this.matrimonialRegimeType = model.matrimonialRegimeType;
    this.otherExplanation = model.otherExplanation;
    this.distributionValuesConfirmedAt = model.distributionValuesConfirmedAt;
  }

  /**
   * @returns {boolean}
   */
  get isPartnershipOfAcquests() {
    return (
      this.matrimonialRegimeType === EstateQuebecMatrimonialRegimeType.PARTNERSHIP_OF_ACQUESTS.key
    );
  }

  /**
   * @returns {boolean}
   */
  get isSeparateAsToProperty() {
    return (
      this.matrimonialRegimeType === EstateQuebecMatrimonialRegimeType.SEPARATE_AS_TO_PROPERTY.key
    );
  }

  /**
   * @returns {boolean}
   */
  get isOther() {
    return this.matrimonialRegimeType === EstateQuebecMatrimonialRegimeType.OTHER.key;
  }

  /**
   * @returns {string}
   */
  get matrimonialRegimeTypeValue() {
    return EstateQuebecMatrimonialRegimeType.getByKey(this.matrimonialRegimeType).value;
  }
}
